import { HeaderHeightContext } from 'contexts/HeaderStateContext'
import { useContext } from 'react'

/**
 * Give this style object to a sticky component
 * that exists in a more nested context than the budget bar
 * so that that component will slide down underneath the
 * budget bar and they will stick together seamlessly
 * @returns a style object
 */
export function useBusinessTravellerStickyBudgetBarHeightContext() {
  const { heights: { businessTravellerBudgetBar: businessTravellerBudgetBarHeight } } = useContext(HeaderHeightContext)

  return { top: businessTravellerBudgetBarHeight }
}
